export const POI__SET_STOP_TYPE = 'POI__SET_STOP_TYPE';
export const POI__SET_PLACEHOLDER = 'POI__SET_PLACEHOLDER';
export const POI__SET_LIST_TYPE = 'POI__SET_LIST_TYPE';
export const POI__SET_SEARCHING_POINT = 'POI__SET_SEARCHING_POINT';
